import React from 'react';
import type { TutorialStepT } from '../../../common/types/types';
const drawPolyline = {
  version: 1,
  id: 'draw-polyline',
  render: () => <div>Click on the stage to draw the polyline, polyline requires at least 2 vertices.</div>,
  disableNext: true,
  nextId: 'end-polyline'
};
const endPolyline = {
  version: 1,
  id: 'end-polyline',
  render: () => <div>Double click to end the polyline and create the final vertex.</div>,
  disableNext: true
};
export const POLYLINE_TUTORIAL_CONFIG = {
  drawPolyline: ({
    ...drawPolyline,
    nextId: endPolyline.id
  } as Omit<TutorialStepT, 'getTarget'>),
  endPolyline: ({
    ...endPolyline
  } as Omit<TutorialStepT, 'getTarget'>)
};